import React, {useEffect, useState} from "react";
import {
    Form,
    LeftContainer,
    RightContainer,
    SideWrapper,
    TextContainer,
} from "../components/SideWrapper/SideWrapper.styles";
import {useLocation, useNavigate} from "react-router-dom";

import {useTranslation} from "react-i18next";
import LogoAndText from "../components/LogoAndText";
import useFormData from "../hooks/useFormData";
import {register} from "../utils/api-lists/login.api";
import {Button, Divider, Modal} from "antd";
import {checkInvitationStatus} from "../utils/api-lists/verification.api";

const InvitationVerifyAndSignUpPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [token, setToken] = useState(
        new URLSearchParams(location.search).get("token") || ""
    );

    const [verification, setVerification] = useState(null);
    const [error, setError] = useState(null);

    const [status, setStatus] = useState({
        type: null,
        message: null,
    });
    const {t} = useTranslation("common");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            await register(
                formData.firstName,
                formData.lastName,
                verification.email,
                formData.password,
                formData.role,
                verification.organization_id,
                token
            );
            setStatus({
                type: "success",
                message: t("success_message"),
            });
            navigate("/login");
        } catch (err) {
            setStatus({
                type: "error",
                message: t("error_registration_failed"),
            });
        }
    };

    const [formData, setFormData] = useFormData({
        firstName: "",
        lastName: "",
        password: "",
        role: ""
    });

    useEffect(() => {
        if (!token) {
            navigate("/");
            return;
        }

        setVerification({
            organization_name: "",
            email: "",
            organization_id: "",
            status: "",
            invitation_id: "",
            token: token
        })
        checkInvitationStatus(token)
            .then((data) => {
                setVerification(data)
            })
            .catch((e) => setError(e));
    }, [token]);

    if (!verification) return;

    return (
        <SideWrapper>
            <LeftContainer>
                <LogoAndText/>
            </LeftContainer>
            <RightContainer>
                <h1>You're Invited to! {verification.organization_name}</h1>
                <p>Email: {verification.email} </p>

                <TextContainer style={{marginBottom: "40px"}}>
                    <h2>{t("sign_up")}</h2>
                    <h3>{t("create_an_account")}</h3>
                </TextContainer>
                <Form onSubmit={handleSubmit}>
                    <label>{t("name")}</label>
                    <input
                        placeholder={t("name")}
                        name="firstName"
                        type="text"
                        autoComplete="new-name"
                        onChange={(e) => setFormData(e)}
                        required
                    />
                    <label>{t("surname")}</label>
                    <input
                        placeholder={t("surname")}
                        name="lastName"
                        type="text"
                        autoComplete="new-surname"
                        onChange={(e) => setFormData(e)}
                        required
                    />
                    <label>{t("password")}</label>
                    <input
                        placeholder={t("password")}
                        name="password"
                        type="password"
                        autoComplete="new-password"
                        onChange={(e) => setFormData(e)}
                        required
                    />
                    <label>{t("role")}</label>
                    <select name="role" onChange={(e) => setFormData(e)}
                            style={{
                                backgroundColor: "#F5F5F5",
                            }}
                    >
                        <option> {t("Select")}</option>
                        <option value="COSMETOLOGIST"> {t("cosmetologist")}</option>
                        <option value="DERMATOLOGIST"> {t("dermatologist")}</option>
                        <option value="BEAUTY_CLINCS"> {t("beauty_clincs")}</option>
                    </select>
                    <Button type="link" style={{margin: 0}} onClick={() => setIsModalVisible(true)} color="yellow">
                        {t("terms_and_conditions")}
                    </Button>

                    <Button
                        type="primary"
                        htmlType="submit"
                    >
                        {t("next")}
                    </Button>
                    {status.type === "error" && (
                        <p style={{color: "red"}}>{status.message}</p>
                    )}
                    {status.type === "success" && (
                        <p style={{color: "green"}}>{status.message}</p>
                    )}
                </Form>
                <p>
                    {t("have_an_account")}{" "}
                    <span onClick={() => navigate("/login")}>{t("sign_in")}</span>
                </p>
            </RightContainer>
            <Modal
                width={{
                    xs: '90%',
                    sm: '90%',
                    md: '90%',
                    lg: '1000px',
                    xl: '1000px',
                    xxl: '1000px',
                }}
                title={t("terms_and_conditions")}
                open={isModalVisible}
                onOk={() => setIsModalVisible(false)}
                onCancel={() => setIsModalVisible(false)}
                footer={[
                    <Button key="ok" type="primary" onClick={() => setIsModalVisible(false)}>
                        {t("ok")}
                    </Button>
                ]}
            >
                <h3>DATA PROTECTION</h3>
                <p>
                    <br/>
                    In accordance with the provisions of any data protection law applicable in Luxembourg
                    (including but not limited to the law of 1st August 2018 on the organization of the National
                    Commission for Data Protection and the general regime on data protection, as may be
                    amended or replaced) and the EU Regulation n°2016/679 of 27 April 2016 on the protection
                    of natural persons with regard to the processing of personal data and on the free movement
                    of such data (the “GDPR”) (collectively hereinafter the “Data Protection Law”), Glacies Biome,
                    the Company, acting as data controller (the “Data Controller”) collects, stores and processes,
                    by electronic or other means, the data supplied by the individuals and/or the prospective
                    participants or, if the prospective is a legal person, any natural person related to the individual
                    and/or the prospective participant such as its contact person(s), employee(s), trustee(s),
                    agent(s), representative(s) and/or beneficial owner(s) (the “Data Subjects”), for the purpose
                    of fulfilling the services required by the participant and complying with its legal and regulatory
                    obligations.
                    <br/>
                    <br/>
                    Such personal data includes (i) for individual: the name, address (including postal and/or e-
                    mail address), banking details; (ii) for corporate: the name and address (including postal and/or
                    e-mail address) of the natural person related to; and (iii) any personal data the processing of
                    which is required in order to comply with regulatory requirements, including tax law and foreign
                    laws (all the personal data mentioned above, collectively, the “Personal Data”). The Data
                    Subjects may, at their discretion, refuse to communicate the Personal Data to the Data
                    Controller. In this event however the Data Controller or its agents may reject its request for
                    subscription for Shares in the Company if the relevant Personal Data is necessary to the
                    subscription of Shares in the Company.
                    <br/>
                    <br/>
                    Participants who are legal persons undertake and guarantee to process Personal Data and to
                    supply such Personal Data to the Company in compliance with the Data Protection Law,
                    including, where appropriate, informing the Data Subjects of the contents of the present
                    section, in accordance with Articles 13 and 14 of the GDPR.
                    <br/>
                    <br/>
                    Personal Data supplied by Data Subjects are processed in order to enter into and execute the
                    subscription in the Company (i.e. to perform any pre-contractual measures as well as the
                    contract entered into by the Data Subjects), for the legitimate interests of the Data Controller
                    and to comply with the legal obligations imposed on the Data Controller. In particular
                    processing sensitive information regarding your personal and health data, collectin / handling
                    / processing DNA material, image consent, all data for research and publication, the Personal
                    Data supplied by Data Subjects is processed for the purpose of (i) maintaining the register of
                    the participant; (ii) processing subscriptions, redemptions and conversions of data; (iii)
                    complying with applicable anti-money laundering rules and other legal obligations, such as
                    maintaining controls in respect of late trading and market timing practices; (iv) account
                    administration; (v) client relationship management and (vi) tax identification as may be required
                    under Luxembourg or foreign laws and regulations (including laws and regulations relating to
                    FATCA or CRS).
                    <br/>
                    <Divider/>
                    The “legitimate interests” of the Data Controller referred to above are:
                    (a) the processing purpose described in point (v) of the above paragraph of this clause;
                    (b) the provision of the proof, in the event of a dispute, of a transaction or any commercial
                    communication;
                    (c) exercising the business of the Company in accordance with reasonable market standards.
                    <br/>
                    <br/>
                    In the context of the above mentioned purposes, the Data Controller may delegate the
                    processing of the Personal Data, in compliance and within the limits of the applicable laws and
                    regulations, to other data recipients which refer to, inter alia, the universities, colleges,
                    shareholders partners the AIFM, the Sub-Advisor, the Investment Advisory, the Depositary, the
                    Paying Agent and the Registrar and Transfer Agent and other entities (the “Recipients”).
                    <br/>
                    <br/>
                    The Recipients may, under their own responsibility, disclose the Personal Data to their agents
                    and/or delegates (the “Sub-Recipients”), which shall process the Personal Data for the sole
                    purposes of assisting the Recipients in providing their services to the Data Controller and/or
                    assisting the Recipients in fulfilling their own legal obligations.
                    <br/>
                    <br/>
                    The Recipients and Sub-Recipients may be located either inside or outside the European
                    Economic Area (the “EEA”).
                    <br/>
                    <br/>
                    Where the Recipients are located outside the EEA in a country which does not ensure an
                    adequate level of protection for Personal Data, the Data Controller will enter into legally binding
                    transfer agreements with the relevant Recipients in the form of the EU Commission’s approved
                    model clauses. Where the Sub-Recipients are located outside the EEA in a country which does
                    not ensure an adequate level of protection for Personal Data, the Recipients shall also enter
                    into legally binding transfer agreements with the relevant Sub-Recipients in the form of the EU
                    Commission’s approved model clauses. In this respect, the Data Subjects have a right to
                    request copies of the relevant document for enabling the Personal Data transfer(s) towards
                    such countries by writing to the Data Controller.
                    <br/>
                    <br/>
                    The Recipients and Sub-Recipients may, as the case may be, process the Personal Data as data
                    processors (when processing the Personal Data upon instructions of the Data Controller), or as
                    distinct data controllers (when processing the Personal Data for their own purposes, namely
                    fulfilling their own legal obligations). The Data Controller may also transfer Personal Data to
                    third parties such as governmental or regulatory agencies including tax authorities, in or outside
                    the European Union, in accordance with applicable laws and regulations. In particular, such Personal
                    Data may be disclosed to the Luxembourg tax authorities, which in turn may, acting as data
                    controller, disclose the same to foreign tax authorities.
                    <br/>

                    <Divider/>
                    <strong>In accordance with the conditions laid down by the Data Protection Law, Data Subjects have
                        the right
                        to:</strong>
                    <br/>
                    <br/>
                    <ul className="list-disc pl-8">
                        <li>request access to their Personal Data;</li>
                        <li>request the correction of their Personal Data where it is inaccurate or incomplete;</li>
                        <li>object to the processing of their Personal Data;</li>
                        <li>request erasure of their Personal Data;</li>
                        <li>request for restriction of the use of their Personal Data;</li>
                        <li>request for Personal Data portability.</li>
                    </ul>
                    <br/>
                    <br/>
                    The Data Subjects may exercise their above rights by writing to the Data Controller at the following
                    address: <a class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                                href="mailto:contact@glaciesbiome.lu"><strong>contact@glaciesbiome.lu</strong></a>
                    <br/>
                    <br/>
                    They are also informed of the existence of their right to lodge a complaint with the Commission
                    Nationale pour la Protection des Données (the “CNPD”)
                    Address: 1, Avenue du Rock’n’Roll, L-4361 Esch-sur-Alzette, Grand-Duchy of Luxembourg
                    or with any competent data protection supervisory authority in their EU Member State of residence.
                    <br/>
                    <Divider/>
                    <strong>Retention:</strong>
                    Personal Data shall not be retained for a period longer than necessary for the purpose of the data
                    processing, subject to any statutory limitation periods.
                    <br/>
                    <Divider/>
                    <strong>Participant Acknowledgement:</strong>
                    By signing this form, you affirm that you are aware of this present full document and agree with the
                    terms and services.
                </p>
            </Modal>
        </SideWrapper>
    );
};

export default InvitationVerifyAndSignUpPage;
